import register from '../register';
import dom from './util/dom';
import jump from './util/jump';
import phoneMask from './util/phone-mask';

let validators = {
  email: validateEmail,
  phone: validatePhone,
  zipcode: validateZip
};

class piRequestForm {

  constructor( context ) {
    this.form = context.querySelector('.info-request-form');
    this.formBody = context.querySelector('.form-container');
    // eslint-disable-next-line max-len
    this.inputs = [ ...context.querySelectorAll('input:not([type="radio"]), select') ];
    this.radios = [ ...context.querySelectorAll('input[type="radio"]') ];
    this.submit = context.querySelector('.inp-submit');

    this.success = context.querySelector('.form-success');

    this.email = this.form.querySelector('.inp-email-address');
    this.phone = this.form.querySelector('.inp-phone');
    this.lastName = this.form.querySelector('.inp-last-name');
    this.zipcode = this.form.querySelector('.inp-zipcode');
    this.agent = this.form.querySelector('#agent');
    this.agentTerms = this.form.querySelector('.agent-terms');

    this.onSubmit = this.onSubmit.bind( this );
    this.getPayload = this.getPayload.bind( this );
    this.submitForm = this.submitForm.bind( this );
    this.onSuccess = this.onSuccess.bind( this );

    this.bindEvents();
    phoneMask( this.phone );
  }

  bindEvents() {
    this.form.addEventListener( 'submit', this.onSubmit, false );
    this.agent.addEventListener( 'change', () => {
      this.agentTerms.classList.toggle( 'hidden', !this.agent.checked );
    });
  }

  onSubmit( e ) {
    e.preventDefault();
    let payload;

    if ( this.validate() ) {
      this.submit.disabled = true;
      this.submit.classList.add('loading');
      payload = this.getPayload();

      payload.applicant = payload.user_type === 'applicant';
      payload.employee = payload.user_type === 'employee';

      delete payload.user_type;

      this.submitForm( payload );
    }
  }

  validate() {
    let radioValid = true;
    let radioGroups = this.radios.reduce( groupRadiosByName, {} );

    for ( let name of Object.keys( radioGroups ) ) {
      const errorClass = 'error';
      const parent = radioGroups[ name ][ 0 ].closest('.inp-group');
      const required = radioGroups[ name ].some( shouldValidate );
      const valid = radioGroups[ name ].some( inp => inp.checked );

      parent.classList.remove( errorClass );

      if ( required && !valid ) {
        parent.classList.add( errorClass );
        radioValid = false;
      }
    }

    return !this.inputs
    .filter( shouldValidate )
    .map( removeError )
    .filter( isInvalid )
    .map( addError ).length && radioValid;
  }

  getPayload() {
    let radios = this.radios.reduce( getRadiosVal, {} );
    let inputs = this.inputs
    .filter( isNotSubmit )
    .reduce( inputReducer, {} );

    return Object.assign( {}, inputs, radios );
  }

  submitForm( payload ) {
    dom.ajax(
      {
        url: '/legal/privacy/request',
        method: 'POST'
      },
      payload,
      ( err, res ) => {
        if ( err ) {
          return;
        }
        this.onSuccess( res );
      }
    );
  }

  onSuccess() {
    this.success.style.display = 'block';
    this.formBody.style.display = 'none';
    jump( document.querySelector('body'), {
      duration: 300,
      offset: 0
    });
  }

}

function getRadiosVal( obj, inp ) {
  obj[ inp.name ] = inp.checked ? inp.value : obj[ inp.name ];
  return obj;
}

function groupRadiosByName( obj, inp ) {
  if ( !obj.hasOwnProperty( inp.name ) ) {
    obj[ inp.name ] = [];
  }
  obj[ inp.name ].push( inp );
  return obj;
}

function init() {
  let ctx = document.querySelector('.privacy-request-section');
  new piRequestForm( ctx );
}

function validateZip( str ) {
  return /^\d{5}(?:[-\s]\d{4})?$/.test( str );
}

function validateEmail( str ) {
  return /\S+@\S+/.test( str );
}

function validatePhone( str ) {
  if ( str.length > 0 ) {
    return ( str.match( /\d/g ) || [] ).length === 10;
  }
  return false;
}

function addError( inp ) {
  let parent = inp.parentNode;
  parent.classList.add('error');
  return inp;
}

function removeError( inp ) {
  let parent = inp.parentNode;
  parent.classList.remove('error');
  return inp;
}

function shouldValidate( inp ) {
  return inp.dataset.validate !== undefined;
}

function isEmpty( inp ) {
  return !inp.value || inp.value === 'none';
}

function isInvalid( inp ) {
  let validate = validators[ inp.dataset.validate ];
  return typeof validate === 'function' ?
    !validate( inp.value ) : isEmpty( inp );
}

function isNotSubmit( inp ) {
  return inp.type !== 'submit';
}

function inputReducer( obj, inp ) {
  // eslint-disable-next-line max-len
  obj[ inp.name ] = inp.type === 'checkbox' ? inp.checked : ( inp.value || null );
  return obj;
}

register( 'pi-request-form', init );

// eslint-disable-next-line no-undef
export default undefined;
